module.exports = __webpack_public_path__ + "static/media/speroni.99d98c6e.svg";